import railsFetch from "./railsFetch";

export default async function putJSON(path, body) {
  const response = await railsFetch(path, {
    method: "PUT",
    body: JSON.stringify(body)
  });
  return await response.json();
}
